import React from 'react';

export const Bell = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
    <path
      d="M7.3998 17H10.5998M3.3998 6.6V10.6L1.7998 13.8H16.1998L14.5998 10.6V6.6C14.5998 5.8646 14.455 5.1364 14.1735 4.45697C13.8921 3.77755 13.4796 3.16021 12.9596 2.6402C12.4396 2.12019 11.8223 1.7077 11.1428 1.42627C10.4634 1.14485 9.73521 1 8.9998 1C8.2644 1 7.5362 1.14485 6.85678 1.42627C6.17735 1.7077 5.56001 2.12019 5.04001 2.6402C4.52 3.16021 4.10751 3.77755 3.82608 4.45697C3.54465 5.1364 3.3998 5.8646 3.3998 6.6Z"
      stroke="currentColor"
      strokeWidth="1.5"
    />
  </svg>
);
